module.exports = __webpack_public_path__ + "static/media/trash.15163944.svg";